// ProcListLayoutSelecter.tsx
// 加工実績一覧のレイアウト選択コンポーネント

import "./ProcListLayoutSelecter.css";

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { setSelectLayout } from "../../redux/procListLayoutSlice";

const ProcListLayoutSelecter: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  // レイアウトデータ（APIから取得したもの）
  const filterdProcListLayout = useSelector(
    (state: RootState) => state.procListLayout.filteredLayouts
  );
  const selectedLayout = useSelector(
    (state: RootState) => state.procListLayout.selectLayout
  );
  // レイアウト選択ボタン（選択した工場・加工・機械に対応するレイアウト）
  const [buttonList, setButtonList] = useState<any[]>([]);
  // 選択ボタン
  const handleLayoutSelectButton = (id: string) => {
    // 選択したレイアウトをreduxのstateに保存
    dispatch(setSelectLayout({ id: id }));
  };

  useEffect(() => {
    // ボタン表示
    setButtonList(
      filterdProcListLayout.map((d) => {
        return (
          <button
            className="layout-button"
            type="button"
            style={{
              backgroundColor:
                selectedLayout?.id === d.id
                  ? "#4AB1CC"
                  : "#F0F0F0",
              color:
                selectedLayout?.id === d.id ? "#fff" : "#000",
            }}
            onClick={() => handleLayoutSelectButton(d.id)}
          >
            {d.layout_name}
          </button>
        );
      })
    );
  }, [filterdProcListLayout, selectedLayout]);

  return (
    <div className="layout-selector-container">
      <div>
        <img
          src="images/layout.svg"
          alt="layout Icon"
          className="icon graph-button"
        />
      </div>
      {buttonList}
    </div>
  );
};

export default ProcListLayoutSelecter;
